import { render, staticRenderFns } from "./AMSqaRegComponent.vue?vue&type=template&id=4c61bab7&scoped=true"
import script from "./AMSqaRegComponent.vue?vue&type=script&lang=js"
export * from "./AMSqaRegComponent.vue?vue&type=script&lang=js"
import style0 from "./AMSqaRegComponent.vue?vue&type=style&index=0&id=4c61bab7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c61bab7",
  null
  
)

export default component.exports